
const updates = {}

let hasPreparedForNextTick = {value: false}

export default {
  updated() {
    updates[this._compName] = (updates[this._compName] || 0) + 1

    if (!hasPreparedForNextTick.value) {
      hasPreparedForNextTick.value = true
      this.$nextTick(() => {
        // console.clear()
        // Object.keys(updates).forEach(key => console.log(key, updates[key]))
        
        hasPreparedForNextTick.value = false
      })
    }
  },
  beforeDestroy() {
    updates[this._compName] = 0
  },
  computed: {
    _compName() {
      return `<${this.$vnode.tag.split("-").reverse()[0]}/>`
    },
  },
}
